import React from 'react';


export const linkifyText = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  // URL regex pattern that matches http/https URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  
  const parts = text.split(urlRegex);
  
  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#0DC1CE',
            textDecoration: 'underline',
            cursor: 'pointer'
          }}
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

/**
 * Компонент, който рендира текст с кликаеми линкове
 * @param {string} text - Текстът за рендиране
 * @returns {JSX.Element} Рендиран текст с кликаеми линкове
 */
export const LinkifiedText = ({ text }) => {
  return <>{linkifyText(text)}</>;
};
